var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audioBox"},_vm._l((_vm.num),function(item,index){return _c('div',{key:index,class:'audio' + item + ' ' + 'wave' + item,style:('background: ' + _vm.color + '; margin-right:' + _vm.marginright + 'px')})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }